document.addEventListener("DOMContentLoaded", () => {
  /* MONELLO_ORDER_STATUS_EMBED_DOCUMENT_V1 */
  const embedMode = new URLSearchParams(window.location.search).get(
    "monello_chat_embed"
  );
  if (embedMode === "bestellstatus") {
    document.documentElement.classList.add("monello-order-status-embed");
    const embedStyle = document.createElement("style");
    embedStyle.textContent = `
      html.monello-order-status-embed,
      html.monello-order-status-embed body {
        margin: 0 !important;
        padding: 0 !important;
        background: #fffdfb !important;
      }
      html.monello-order-status-embed .monello-chat,
      html.monello-order-status-embed .shopify-section-group-header-group,
      html.monello-order-status-embed .shopify-section-group-footer-group,
      html.monello-order-status-embed #shopify-section-header,
      html.monello-order-status-embed #shopify-section-footer,
      html.monello-order-status-embed #shopify-section-announcement-bar {
        display: none !important;
      }
      html.monello-order-status-embed #MainContent,
      html.monello-order-status-embed main {
        width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        padding: 8px !important;
        background: #fffdfb !important;
      }
    `;
    document.head.appendChild(embedStyle);
    document.querySelector(".monello-chat")?.remove();
    return;
  }

  const widget = document.querySelector(".monello-chat");

  if (!widget) return;

  const launcher = widget.querySelector(
    ".monello-chat__launcher"
  );

  const windowElement = widget.querySelector(
    ".monello-chat__window"
  );

  const closeButton = widget.querySelector(
    ".monello-chat__close"
  );

  const content = widget.querySelector(
    ".monello-chat__content"
  );

  const originalLauncherContent = launcher.innerHTML;

  setupMobileLauncher();
  setupCompactChatDesign();
  setupHeaderChatIcon();

  const apiUrl =
    "https://monello-ai-production.up.railway.app/chat/message";
  const privacyUrl =
    "https://monello-tierurnen.de/pages/datenschutz";
  const deleteChatUrl =
    "https://monello-ai-production.up.railway.app/chat/privacy/delete";
  const chatHistoryUrl =
    "https://monello-ai-production.up.railway.app/chat/live/";
  const customerContextUrl =
    "https://monello-ai-production.up.railway.app/chat/customer-context";

  const initialContent = content.innerHTML;
  const shopifyCustomerId = detectShopifyCustomerId();
  const sessionId = getSessionId(shopifyCustomerId);
  const pageActivityUrl =
    "https://monello-ai-production.up.railway.app/chat/page-activity";
  const trackingStorageKey = "monello_chat_page_tracking_active";
  const windowOpenStorageKey = "monello_chat_window_open";
  let pageTrackingTimer = null;
  let livePollingTimer = null;
  let lastMessageId = 0;
  let messageRequestInFlight = false;
  let unreadAgentMessages = 0;

  syncShopifyCustomerContext(shopifyCustomerId);

  content.addEventListener("click", (event) => {
    /* MONELLO_ORDER_STATUS_LINK_INTERCEPT_V1 */
    const trackingLink = event.target.closest(
      'a[href*="/pages/bestellstatus"]'
    );
    if (
      trackingLink &&
      !trackingLink.hasAttribute("data-order-status-external")
    ) {
      event.preventDefault();
      renderOrderStatusPage(restoreConversation);
      return;
    }

    const resetButton = event.target.closest(".monello-chat__new-chat");
    if (!resetButton) return;
    sessionStorage.removeItem("monello_chat_session_id");
    sessionStorage.removeItem("monello_chat_session_identity");
    sessionStorage.removeItem(trackingStorageKey);
    sessionStorage.removeItem(windowOpenStorageKey);
    localStorage.removeItem("monello_chat_session_id");
    localStorage.removeItem("monello_chat_session_identity");
    window.location.reload();
  });

  function collectProductPageContext() {
    if (!window.location.pathname.includes("/products/")) return "";

    const root = document.querySelector("main") || document.body;
    const contentLines = [];
    const seenLines = new Set();

    root.querySelectorAll(
      "h1, h2, h3, p, li, th, td, summary, [class*='product'] label, " +
      ".gpo-app label, .gpo-app .gpo-label, .gpo-app .gpo-option, " +
      ".gpo-app [data-value]"
    ).forEach((element) => {
      if (element.closest(".monello-chat")) return;
      const line = String(element.innerText || element.textContent || "")
        .replace(/\s+/g, " ")
        .trim();
      if (!line || line.length > 800 || seenLines.has(line)) return;
      seenLines.add(line);
      contentLines.push(line);
    });

    const optionGroups = new Map();
    const addOption = (name, value) => {
      const cleanName = String(name || "").replace(/\s+/g, " ").trim();
      const cleanValue = String(value || "").replace(/\s+/g, " ").trim();
      if (!cleanName || !cleanValue || cleanValue.length > 200) return;
      if (/email|telefon|phone|customer|kunde|bestell/i.test(cleanName)) return;
      if (!optionGroups.has(cleanName)) optionGroups.set(cleanName, new Set());
      optionGroups.get(cleanName).add(cleanValue);
    };

    root.querySelectorAll("select").forEach((select) => {
      if (select.closest(".monello-chat")) return;
      Array.from(select.options || []).forEach((option) => {
        if (option.value && !option.disabled) {
          addOption(select.name || select.getAttribute("aria-label"), option.textContent);
        }
      });
    });

    root.querySelectorAll(
      'input[type="radio"], input[type="checkbox"]'
    ).forEach((input) => {
      if (input.closest(".monello-chat")) return;
      addOption(
        input.name || input.getAttribute("aria-label"),
        input.value || input.getAttribute("data-value")
      );
    });

    const optionLines = Array.from(optionGroups.entries()).map(
      ([name, values]) => `${name}: ${Array.from(values).join(", ")}`
    );

    return [
      "Sichtbarer Inhalt der aktuell geöffneten Produktseite:",
      ...contentLines,
      "",
      "Dynamisch eingeblendete Auswahlmöglichkeiten aus Produkt-Apps:",
      ...optionLines,
    ].join("\n").slice(0, 16000);
  }

  async function pollLiveUpdates() {
    if (messageRequestInFlight || document.hidden) return;
    try {
      const response = await fetch(
        `${chatHistoryUrl}${encodeURIComponent(sessionId)}?after_id=${lastMessageId}&mark_agent_read=${windowElement.hidden ? "false" : "true"}`,
        { cache: "no-store" }
      );
      if (!response.ok) return;
      const data = await response.json();
      const messages = content.querySelector(".monello-chat__messages");
      for (const item of data.messages || []) {
        const itemId = Number(item.id || 0);
        if (itemId <= lastMessageId) continue;
        lastMessageId = itemId;
        if (item.role === "agent" && windowElement.hidden) {
          unreadAgentMessages += 1;
          updateUnreadAgentBadge();
        }
        if (!messages || !["user", "assistant", "agent"].includes(item.role)) {
          continue;
        }
        addMessage(
          messages,
          item.content,
          item.role === "user" ? "user" : "assistant"
        );
      }
      lastMessageId = Math.max(lastMessageId, Number(data.last_id || 0));
    } catch (_error) {
      // Ein kurzzeitiger Pollingfehler darf das Kundengespräch nicht stören.
    }
  }

  function updateUnreadAgentBadge() {
    let badge = launcher.querySelector(".monello-chat__unread-badge");
    if (!unreadAgentMessages) {
      if (badge) badge.remove();
      launcher.removeAttribute("data-has-unread");
      return;
    }
    launcher.setAttribute("data-has-unread", "true");
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "monello-chat__unread-badge";
      badge.style.cssText = [
        "position:absolute",
        "right:-4px",
        "top:-5px",
        "min-width:22px",
        "height:22px",
        "padding:0 6px",
        "display:inline-flex",
        "align-items:center",
        "justify-content:center",
        "border:2px solid #fff",
        "border-radius:999px",
        "background:#c43d3d",
        "color:#fff",
        "font:700 12px/1 Arial,sans-serif",
        "box-shadow:0 4px 12px rgba(80,35,35,.28)",
      ].join(";");
      launcher.style.position = "relative";
      launcher.appendChild(badge);
    }
    badge.textContent = String(Math.min(unreadAgentMessages, 9));
    launcher.setAttribute(
      "aria-label",
      unreadAgentMessages === 1
        ? "Eine neue Antwort von Monello – Chat öffnen"
        : `${unreadAgentMessages} neue Antworten von Monello – Chat öffnen`
    );
    launcher.classList.add("monello-chat__launcher--hint-visible");
  }

  function startLivePolling() {
    if (livePollingTimer) return;
    pollLiveUpdates();
    livePollingTimer = window.setInterval(pollLiveUpdates, 2000);
  }

  function stopLivePolling() {
    if (!livePollingTimer) return;
    window.clearInterval(livePollingTimer);
    livePollingTimer = null;
  }

  function sendPageActivity(active = true) {
    const payload = JSON.stringify({
      session_id: sessionId,
      page_url: window.location.href,
      page_title: document.title,
      active: active,
    });

    if (!active && navigator.sendBeacon) {
      navigator.sendBeacon(
        pageActivityUrl,
        new Blob([payload], { type: "application/json" })
      );
      return;
    }

    fetch(pageActivityUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch(() => {});
  }

  function startPageTracking() {
    sessionStorage.setItem(trackingStorageKey, "1");
    sendPageActivity(true);
    if (!pageTrackingTimer) {
      pageTrackingTimer = window.setInterval(
        () => sendPageActivity(true),
        15000
      );
    }
    startLivePolling();
  }

  function stopPageTracking() {
    sessionStorage.removeItem(trackingStorageKey);
    if (pageTrackingTimer) {
      window.clearInterval(pageTrackingTimer);
      pageTrackingTimer = null;
    }
    // Live-Antworten werden auch bei minimiertem Chat weiter abgerufen.
    sendPageActivity(false);
  }

  if (sessionStorage.getItem(trackingStorageKey) === "1") {
    startPageTracking();
  }

  launcher.addEventListener("click", () => {
    launcher.classList.remove(
      "monello-chat__launcher--hint-visible"
    );
    launcher.hidden = true;
    windowElement.hidden = false;
    unreadAgentMessages = 0;
    updateUnreadAgentBadge();
    sessionStorage.setItem(windowOpenStorageKey, "1");
    startPageTracking();
  });

  closeButton.addEventListener("click", () => {
    windowElement.hidden = true;
    launcher.hidden = false;
    sessionStorage.removeItem(windowOpenStorageKey);
    stopPageTracking();
  });

  document.addEventListener("visibilitychange", () => {
    if (sessionStorage.getItem(trackingStorageKey) !== "1") return;
    sendPageActivity(!document.hidden);
  });

  renderHome();
  restoreConversation();

  async function restoreConversation() {
    if (sessionStorage.getItem(windowOpenStorageKey) === "1") {
      launcher.hidden = true;
      windowElement.hidden = false;
    }

    try {
      const response = await fetch(
        `${chatHistoryUrl}${encodeURIComponent(sessionId)}?after_id=0&mark_agent_read=${windowElement.hidden ? "false" : "true"}`,
        { cache: "no-store" }
      );
      if (!response.ok) return;

      const data = await response.json();
      lastMessageId = Math.max(lastMessageId, Number(data.last_id || 0));
      const history = (data.messages || []).filter((item) =>
        ["user", "assistant", "agent"].includes(item.role)
      );
      if (!history.length) {
        startLivePolling();
        return;
      }

      showConversation(renderHome);
      const messages = content.querySelector(".monello-chat__messages");
      if (!messages) return;

      history.forEach((item) => {
        addMessage(
          messages,
          item.content,
          item.role === "user" ? "user" : "assistant"
        );
      });
      startLivePolling();
    } catch (_error) {
      // Ein vorübergehender Abruf-Fehler darf den Chat nicht blockieren.
      startLivePolling();
    }
  }

  function setupMobileLauncher() {
    const mobileQuery = window.matchMedia(
      "(max-width: 749px)"
    );
    const hintStorageKey =
      "monello_chat_mobile_hint_seen";
    let collapseTimer = null;

    const style = document.createElement("style");
    style.textContent = `
      @media (max-width: 749px) {
        .monello-chat .monello-chat__launcher {
          width: 60px !important;
          min-width: 60px !important;
          height: 60px !important;
          padding: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 10px !important;
          overflow: hidden !important;
          white-space: nowrap !important;
          border-radius: 999px !important;
          transition: width .35s ease, padding .35s ease !important;
        }

        .monello-chat .monello-chat__launcher[hidden] {
          display: none !important;
        }

        .monello-chat .monello-chat__launcher--hint-visible {
          width: 202px !important;
          padding: 0 18px 0 13px !important;
          justify-content: flex-start !important;
        }

        .monello-chat__launcher-icon {
          position: relative;
          width: 36px;
          height: 38px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex: 0 0 36px;
          font-size: 31px;
          line-height: 1;
        }

        .monello-chat__launcher-heart {
          position: absolute;
          right: -3px;
          bottom: 0;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 19px;
          height: 19px;
          border-radius: 50%;
          background: #4a403b;
          color: #fff;
          font-size: 12px;
          line-height: 1;
        }

        .monello-chat__launcher-label {
          max-width: 0;
          overflow: hidden;
          opacity: 0;
          font-size: 14px;
          font-weight: 700;
          line-height: 1;
          transition: max-width .3s ease, opacity .2s ease;
        }

        .monello-chat__launcher--hint-visible
        .monello-chat__launcher-label {
          max-width: 125px;
          opacity: 1;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .monello-chat .monello-chat__launcher,
        .monello-chat__launcher-label {
          transition: none !important;
        }
      }
    `;
    document.head.appendChild(style);

    function renderMobileLauncher() {
      if (!mobileQuery.matches) return;

      launcher.innerHTML = `
        <span
          class="monello-chat__brand-chat-icon"
          aria-hidden="true"
        >
          <span class="monello-chat__brand-chat-bubble"></span>
          <span class="monello-chat__brand-chat-heart">🤍</span>
        </span>
        <span class="monello-chat__launcher-label">
          Hilfe &amp; Beratung
        </span>
      `;
      launcher.setAttribute(
        "aria-label",
        "Hilfe und Beratung im Chat öffnen"
      );

      if (
        !localStorage.getItem(hintStorageKey) &&
        !launcher.hidden
      ) {
        launcher.classList.add(
          "monello-chat__launcher--hint-visible"
        );
        localStorage.setItem(hintStorageKey, "1");

        collapseTimer = window.setTimeout(() => {
          launcher.classList.remove(
            "monello-chat__launcher--hint-visible"
          );
        }, 5000);
      }
    }

    renderMobileLauncher();

    mobileQuery.addEventListener("change", (event) => {
      if (event.matches) {
        renderMobileLauncher();
      } else {
        window.clearTimeout(collapseTimer);
        launcher.classList.remove(
          "monello-chat__launcher--hint-visible"
        );
        launcher.innerHTML = originalLauncherContent;
      }
    });
  }

  function detectShopifyCustomerId() {
    const normalize = (value) => {
      const match = String(value || "").match(/[0-9]{1,30}/);
      return match ? match[0] : "";
    };

    const directCandidates = [
      window.ShopifyAnalytics?.meta?.page?.customerId,
      window.ShopifyAnalytics?.meta?.page?.customer_id,
      window.Shopify?.customerId,
      window.__st?.cid,
      window.XBWishlistConfig?.customerId,
    ];
    for (const candidate of directCandidates) {
      const normalized = normalize(candidate);
      if (normalized) return normalized;
    }

    // Several Shopify theme apps render the logged-in customer ID in an
    // inline configuration block. Only the numeric ID is read; name and
    // e-mail are resolved by our backend directly from Shopify.
    const patterns = [
      /customerId\s*:\s*["']([0-9]{1,30})["']/g,
      /["']customerId["']\s*:\s*["']?([0-9]{1,30})["']?/g,
      /logged_in_customer_id["']?\s*[:=]\s*["']?([0-9]{1,30})["']?/g,
    ];
    for (const script of Array.from(document.scripts)) {
      const source = String(script.textContent || "");
      if (!source || !/customer/i.test(source)) continue;
      for (const pattern of patterns) {
        pattern.lastIndex = 0;
        const match = pattern.exec(source);
        if (match?.[1]) return match[1];
      }
    }
    return "";
  }

  async function syncShopifyCustomerContext(customerId) {
    if (!customerId) return;
    try {
      await fetch(customerContextUrl, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          session_id: sessionId,
          shopify_customer_id: customerId,
        }),
      });
    } catch (_error) {
      // Die Kontozuordnung ist Zusatzkomfort und darf den Chat nie blockieren.
    }
  }

  function getSessionId(shopifyCustomerId = "") {
    const storageKey = "monello_chat_session_id";
    const identityStorageKey = "monello_chat_session_identity";
    const currentIdentity = String(shopifyCustomerId || "").trim() || "anonymous";
    const previousIdentity = sessionStorage.getItem(identityStorageKey);
    let storedSessionId = sessionStorage.getItem(storageKey);

    if (storedSessionId && previousIdentity && previousIdentity !== currentIdentity) {
      sessionStorage.removeItem(storageKey);
      sessionStorage.removeItem(trackingStorageKey);
      sessionStorage.removeItem(windowOpenStorageKey);
      storedSessionId = "";
    }

    if (!storedSessionId) {
      storedSessionId = "monello-" + Date.now() + "-" + Math.random().toString(36).slice(2);
      sessionStorage.setItem(storageKey, storedSessionId);
    }

    sessionStorage.setItem(identityStorageKey, currentIdentity);
    localStorage.removeItem(storageKey);
    localStorage.removeItem(identityStorageKey);
    return storedSessionId;
  }

  function setupCompactChatDesign() {
    const style = document.createElement("style");
    style.textContent = `
      .monello-chat__window {
        overflow: hidden !important;
        border: 1px solid rgba(185, 139, 115, .22) !important;
        border-radius: 23px !important;
        background: #fffdfb !important;
        box-shadow:
          0 24px 60px rgba(70, 48, 40, .16),
          0 0 0 1px rgba(255, 255, 255, .82) inset !important;
      }

      .monello-chat__header {
        min-height: 0 !important;
        padding: 10px 13px !important;
        border-bottom: 1px solid #eadbd3 !important;
        background: linear-gradient(135deg, #fffaf7 0%, #f7ede8 100%) !important;
        color: #3b302c !important;
      }

      .monello-chat__window:not([hidden]) {
        display: flex !important;
        flex-direction: column !important;
      }

      .monello-chat__window[hidden] {
        display: none !important;
      }

      .monello-chat__header img,
      .monello-chat__header-avatar,
      .monello-chat__avatar {
        width: 38px !important;
        height: 38px !important;
      }

      .monello-chat__brand-chat-icon {
        position: relative;
        width: 40px;
        height: 40px;
        flex: 0 0 40px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(185, 139, 115, .16);
        border-radius: 50%;
        background: #fff;
        box-shadow: 0 7px 18px rgba(80, 55, 45, .12);
        font-size: 0;
        line-height: 1;
      }

      .monello-chat__brand-chat-bubble {
        position: relative;
        width: 22px;
        height: 17px;
        display: block;
        border-radius: 7px;
        background: linear-gradient(135deg, #b98b73, #8f624f);
        box-shadow: 0 4px 10px rgba(143, 98, 79, .24);
      }

      .monello-chat__brand-chat-bubble::after {
        content: "";
        position: absolute;
        left: 4px;
        bottom: -4px;
        width: 8px;
        height: 8px;
        background: #8f624f;
        clip-path: polygon(0 0, 100% 0, 0 100%);
      }

      .monello-chat__brand-chat-heart {
        position: absolute;
        right: -3px;
        bottom: -2px;
        width: 17px;
        height: 17px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #fff;
        border-radius: 50%;
        background: #8f624f;
        color: #fff;
        font-size: 9px;
        line-height: 1;
      }

      .monello-chat__header-copy,
      .monello-chat__header-copy * {
        opacity: 1 !important;
        visibility: visible !important;
      }

      .monello-chat__close {
        width: 36px !important;
        height: 36px !important;
        min-width: 36px !important;
        background: rgba(185, 139, 115, .12) !important;
        color: #3b302c !important;
      }

      .monello-chat__header h1,
      .monello-chat__header h2,
      .monello-chat__header h3,
      .monello-chat__header strong,
      .monello-chat__title {
        margin: 0 0 2px !important;
        font-size: 15px !important;
        line-height: 1.15 !important;
        color: #3b302c !important;
        -webkit-text-fill-color: #3b302c !important;
        opacity: 1 !important;
      }

      .monello-chat__header p,
      .monello-chat__header small,
      .monello-chat__subtitle {
        margin: 0 !important;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        font-size: 11px !important;
        line-height: 1.2 !important;
        color: #71605a !important;
        -webkit-text-fill-color: #71605a !important;
        opacity: 1 !important;
      }

      .monello-chat__content {
        position: relative !important;
        padding: 14px !important;
        background: linear-gradient(180deg, #fffdfb 0%, #fdf9f7 100%) !important;
        display: flex !important;
        flex: 1 1 auto !important;
        min-height: 0 !important;
        flex-direction: column !important;
        overflow: auto !important;
      }

      .monello-chat__compact-home {
        display: flex;
        width: 100%;
        height: 100%;
        flex: 1 1 auto;
        min-height: 100%;
        flex-direction: column;
        gap: 12px;
        padding-bottom: 106px;
      }

      .monello-chat__compact-welcome {
        margin: 0;
        color: #3b302c;
        font-size: 15px;
        font-weight: 650;
        line-height: 1.35;
      }

      .monello-chat__quick-start {
        width: 100%;
        min-height: 52px;
        padding: 7px 12px 7px 8px;
        display: flex;
        align-items: center;
        gap: 10px;
        border: 1px solid rgba(185, 139, 115, .26);
        border-radius: 17px;
        background: linear-gradient(135deg, rgba(255,255,255,.99) 0%, #fff9f5 56%, #f5e6de 100%);
        color: #4a3b35;
        cursor: pointer;
        font: inherit;
        box-shadow:
          0 9px 22px rgba(80, 55, 45, .10),
          0 0 17px rgba(200, 164, 93, .16),
          inset 0 1px 0 rgba(255, 255, 255, .95);
        transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
        text-align: left;
      }

      .monello-chat__quick-start-icon {
        width: 36px;
        height: 36px;
        flex: 0 0 36px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 13px;
        background: linear-gradient(135deg, #c29a84, #9a6956);
        color: #fff;
        box-shadow: 0 6px 14px rgba(143, 98, 79, .24), 0 0 12px rgba(200, 164, 93, .18);
        font-size: 17px;
      }

      .monello-chat__quick-start-copy {
        min-width: 0;
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        gap: 1px;
      }

      .monello-chat__quick-start-title {
        color: #4a3b35;
        font-size: 13px;
        font-weight: 750;
        line-height: 1.15;
      }

      .monello-chat__quick-start-subtitle {
        color: #806e66;
        font-size: 10.5px;
        font-weight: 500;
        line-height: 1.2;
      }

      .monello-chat__quick-start-arrow {
        color: #9a6956;
        font-size: 20px;
        line-height: 1;
      }

      .monello-chat__quick-start:hover {
        transform: translateY(-2px);
        border-color: rgba(185, 139, 115, .46);
        box-shadow:
          0 13px 28px rgba(80, 55, 45, .14),
          0 0 22px rgba(200, 164, 93, .25),
          0 0 0 3px rgba(200, 164, 93, .08);
      }

      .monello-chat__bottom-area {
        position: absolute !important;
        left: 10px !important;
        right: 10px !important;
        bottom: 7px !important;
        display: block !important;
        gap: 4px !important;
        z-index: 3;
      }

      .monello-chat__start-form {
        position: relative !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
        width: auto !important;
        display: grid !important;
        grid-template-columns: minmax(0, 1fr) !important;
        gap: 4px !important;
      }

      .monello-chat__composer-row {
        position: relative !important;
        display: flex !important;
        align-items: flex-end !important;
        width: 100% !important;
        min-width: 0 !important;
      }

      .monello-chat__start-form > .monello-chat__privacy-note,
      .monello-chat__form > .monello-chat__privacy-note {
        position: static !important;
        display: block !important;
        order: 99 !important;
        width: 100% !important;
        margin: 0 !important;
        padding: 0 3px !important;
        pointer-events: auto !important;
        z-index: 5 !important;
      }

      .monello-chat__privacy-note a,
      .monello-chat__privacy-note button {
        pointer-events: auto !important;
      }


      /* MONELLO_ORDER_STATUS_EMBED_UI_V1 */
      .monello-chat__order-status-page {
        width: 100%;
        height: 100%;
        min-height: 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .monello-chat__order-status-toolbar {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 2px 1px 5px;
      }

      .monello-chat__order-status-title {
        flex: 1 1 auto;
        color: #3b302c;
        font-size: 13px;
        font-weight: 750;
        text-align: center;
      }

      .monello-chat__order-status-back,
      .monello-chat__order-status-external {
        flex: 0 0 auto;
        padding: 6px 8px;
        border: 0;
        border-radius: 9px;
        background: #f8f0eb;
        color: #8f624f;
        font: inherit;
        font-size: 11px;
        font-weight: 700;
        line-height: 1.2;
        text-decoration: none;
        cursor: pointer;
      }

      .monello-chat__order-status-frame-wrap {
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;
        border: 1px solid #eadbd3;
        border-radius: 15px;
        background: #fffdfb;
        box-shadow: 0 8px 22px rgba(80, 55, 45, .08);
      }

      .monello-chat__order-status-frame {
        display: block;
        width: 100%;
        height: 100%;
        min-height: 470px;
        border: 0;
        background: #fffdfb;
      }

      @media (max-width: 749px) {
        .monello-chat__order-status-frame {
          min-height: calc(100vh - 150px);
        }
      }

      /* MONELLO_ORDER_TRACKING_GLOW_BUTTON_V1 */
      .monello-chat__message-bubble a[href*="/pages/bestellstatus"] {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
        margin: 6px 0 2px !important;
        padding: 11px 16px !important;
        border: 1px solid rgba(210, 177, 111, .46) !important;
        border-radius: 14px !important;
        background: linear-gradient(135deg, #b98b73 0%, #9a6956 58%, #805747 100%) !important;
        color: #fff !important;
        -webkit-text-fill-color: #fff !important;
        text-decoration: none !important;
        font-size: 12.5px !important;
        font-weight: 750 !important;
        line-height: 1.2 !important;
        letter-spacing: .01em !important;
        box-shadow:
          0 9px 22px rgba(103, 70, 56, .22),
          0 0 18px rgba(210, 177, 111, .24),
          inset 0 1px 0 rgba(255, 255, 255, .32) !important;
        transition:
          transform .18s ease,
          box-shadow .18s ease,
          border-color .18s ease !important;
      }

      .monello-chat__message-bubble a[href*="/pages/bestellstatus"]::before {
        content: "✦";
        color: #f7e6bd;
        -webkit-text-fill-color: #f7e6bd;
        font-size: 11px;
        line-height: 1;
        filter: drop-shadow(0 0 5px rgba(247, 230, 189, .42));
      }

      .monello-chat__message-bubble a[href*="/pages/bestellstatus"] strong,
      .monello-chat__message-bubble a[href*="/pages/bestellstatus"] span {
        color: #fff !important;
        -webkit-text-fill-color: #fff !important;
      }

      .monello-chat__message-bubble a[href*="/pages/bestellstatus"]:hover {
        transform: translateY(-1px) !important;
        border-color: rgba(226, 195, 129, .68) !important;
        box-shadow:
          0 12px 27px rgba(103, 70, 56, .27),
          0 0 24px rgba(210, 177, 111, .34),
          0 0 0 3px rgba(210, 177, 111, .08),
          inset 0 1px 0 rgba(255, 255, 255, .36) !important;
      }

      .monello-chat__message-bubble a[href*="/pages/bestellstatus"]:focus-visible {
        outline: 3px solid rgba(185, 139, 115, .25) !important;
        outline-offset: 3px !important;
      }

      @media (max-width: 749px) {
        .monello-chat__message-bubble a[href*="/pages/bestellstatus"] {
          width: 100% !important;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .monello-chat__message-bubble a[href*="/pages/bestellstatus"] {
          transition: none !important;
        }
      }

      .monello-chat__start-input,
      .monello-chat__input {
        flex: 1 1 auto;
        min-width: 0;
        width: 100% !important;
        min-height: 48px;
        max-height: 220px;
        padding: 12px 58px 12px 14px;
        resize: none;
        overflow-y: hidden;
        border: 1px solid #dccbc2;
        border-radius: 20px;
        background: #fff;
        color: #3b302c;
        font: inherit;
        font-size: 14px;
        line-height: 1.35;
      }

      .monello-chat__start-form .monello-chat__start-input {
        padding-left: 54px;
      }

      .monello-chat__start-form .monello-chat__attach {
        position: absolute;
        left: 4px;
        bottom: 4px;
        z-index: 2;
        width: 40px !important;
        height: 40px !important;
        min-width: 40px !important;
        padding: 0 !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        line-height: 1 !important;
      }

      .monello-chat__start-input:focus,
      .monello-chat__input:focus {
        outline: 4px solid rgba(185, 139, 115, .11);
        border-color: #b98b73;
      }

      .monello-chat__quick-page {
        display: flex;
        flex-direction: column;
        gap: 11px;
        padding-bottom: 4px;
      }

      .monello-chat__quick-heading {
        margin: 0;
        color: #3b302c !important;
        -webkit-text-fill-color: #3b302c !important;
        opacity: 1 !important;
        visibility: visible !important;
        font-size: 15px;
        font-weight: 700;
        line-height: 1.2;
      }

      .monello-chat__quick-section-title {
        margin: 3px 0 -3px;
        color: #8f624f;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .04em;
        text-transform: uppercase;
      }

      .monello-chat__quick-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 8px;
      }

      .monello-chat__quick-card {
        min-height: 54px;
        padding: 9px 10px;
        display: flex;
        align-items: center;
        gap: 8px;
        border: 1px solid #eadbd3;
        border-radius: 16px;
        background: linear-gradient(145deg, #fff 0%, #fffaf7 100%);
        color: #3b302c;
        cursor: pointer;
        font: inherit;
        font-size: 12px;
        font-weight: 700;
        line-height: 1.2;
        text-align: left;
        text-decoration: none;
        box-shadow: 0 7px 18px rgba(80, 55, 45, .06);
        transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
      }

      .monello-chat__quick-card:hover {
        transform: translateY(-1px);
        border-color: rgba(185, 139, 115, .52);
        background: #fffaf7;
        box-shadow: 0 11px 24px rgba(80, 55, 45, .11), 0 0 15px rgba(200, 164, 93, .12);
      }

      .monello-chat__quick-icon {
        flex: 0 0 auto;
        width: 32px;
        height: 32px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: #f8f0eb;
        font-size: 16px;
      }

      .monello-chat__back--compact {
        align-self: flex-start;
        padding: 4px 0;
        border: 0;
        background: transparent;
        color: #8f624f;
        cursor: pointer;
        font: inherit;
        font-size: 12px;
        font-weight: 700;
      }

      .monello-chat__finder-info {
        margin: 0;
        color: #756461;
        font-size: 13px;
        line-height: 1.45;
      }

      .monello-chat__finder-links {
        display: grid;
        gap: 9px;
      }

      .monello-chat__finder-link {
        padding: 12px 13px;
        border-radius: 12px;
        background: linear-gradient(135deg, #b98b73, #8f624f);
        color: #fff;
        font-size: 13px;
        font-weight: 700;
        text-align: center;
        text-decoration: none;
      }

      /* MONELLO_CHAT_FORM_TEXT_COLORS_V1 */
      .monello-chat__assignment-form,
      .monello-chat__complaint-form,
      .monello-chat__callback-form {
        color: #3b302c !important;
        -webkit-text-fill-color: #3b302c !important;
        opacity: 1 !important;
      }

      .monello-chat__assignment-form p,
      .monello-chat__assignment-form small,
      .monello-chat__assignment-form label,
      .monello-chat__complaint-form p,
      .monello-chat__complaint-form small,
      .monello-chat__complaint-form label,
      .monello-chat__callback-form p,
      .monello-chat__callback-form small,
      .monello-chat__callback-form label {
        color: #65564f !important;
        -webkit-text-fill-color: #65564f !important;
        opacity: 1 !important;
      }

      .monello-chat__assignment-form strong,
      .monello-chat__complaint-form strong,
      .monello-chat__callback-form strong {
        color: #3b302c !important;
        -webkit-text-fill-color: #3b302c !important;
        opacity: 1 !important;
      }

      .monello-chat__assignment-form input,
      .monello-chat__assignment-form textarea,
      .monello-chat__assignment-form select,
      .monello-chat__complaint-form input,
      .monello-chat__complaint-form textarea,
      .monello-chat__complaint-form select,
      .monello-chat__callback-form input,
      .monello-chat__callback-form textarea,
      .monello-chat__callback-form select {
        color: #3b302c !important;
        -webkit-text-fill-color: #3b302c !important;
        opacity: 1 !important;
      }

      .monello-chat__assignment-form input::placeholder,
      .monello-chat__assignment-form textarea::placeholder,
      .monello-chat__complaint-form input::placeholder,
      .monello-chat__complaint-form textarea::placeholder,
      .monello-chat__callback-form input::placeholder,
      .monello-chat__callback-form textarea::placeholder {
        color: #8a7a73 !important;
        -webkit-text-fill-color: #8a7a73 !important;
        opacity: 1 !important;
      }

      .monello-chat__form {
        padding: 10px !important;
      }

      .monello-chat__form-row {
        align-items: flex-end !important;
      }

      .monello-chat__send {
        flex: 0 0 44px !important;
        width: 44px !important;
        height: 44px !important;
        border: 0 !important;
        background: linear-gradient(135deg, #b98b73, #8f624f) !important;
        color: #fff !important;
      }

      .monello-chat__start-form .monello-chat__send {
        position: absolute !important;
        right: 4px !important;
        bottom: 3px !important;
        z-index: 2;
      }

      .monello-chat__message--user .monello-chat__message-bubble {
        background: linear-gradient(135deg, #b98b73, #8f624f) !important;
        color: #fff !important;
      }

      @media (max-width: 749px) {
        .monello-chat .monello-chat__launcher {
          background: linear-gradient(135deg, #b98b73, #8f624f) !important;
          box-shadow: 0 9px 25px rgba(143, 98, 79, .32), 0 0 18px rgba(200, 164, 93, .24) !important;
        }

        .monello-chat__launcher-heart {
          background: #8f624f !important;
        }
      }

      .monello-chat__form-label {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        overflow: hidden !important;
        clip: rect(0 0 0 0) !important;
      }

      @media (max-width: 380px) {
        .monello-chat__quick-grid {
          grid-template-columns: 1fr;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function setupHeaderChatIcon() {
    const header = widget.querySelector(".monello-chat__header");
    if (!header) return;

    const title = header.querySelector(
      ".monello-chat__title, h1, h2, h3, strong"
    );
    let copyBlock = title;
    while (copyBlock && copyBlock.parentElement !== header) {
      copyBlock = copyBlock.parentElement;
    }
    if (copyBlock) copyBlock.classList.add("monello-chat__header-copy");

    // Manche Theme-Versionen legen das bisherige Logo zusammen mit dem
    // Text in denselben Wrapper. Dieses alte Symbol gezielt entfernen,
    // ohne Titel oder Untertitel anzutasten.
    if (copyBlock && title) {
      const oldVisuals = copyBlock.querySelectorAll(
        "img, svg, .monello-chat__header-avatar, .monello-chat__avatar, [class*='logo']"
      );
      oldVisuals.forEach((visual) => {
        let removable = visual;
        while (
          removable.parentElement &&
          removable.parentElement !== copyBlock &&
          !removable.parentElement.contains(title)
        ) {
          removable = removable.parentElement;
        }
        if (!removable.contains(title)) removable.remove();
      });
    }

    const replacement = document.createElement("span");
    replacement.className = "monello-chat__brand-chat-icon";
    replacement.setAttribute("aria-hidden", "true");
    replacement.innerHTML = `<span class="monello-chat__brand-chat-bubble"></span><span class="monello-chat__brand-chat-heart">🤍</span>`;

    const previous = copyBlock?.previousElementSibling;
    if (previous && !previous.matches(".monello-chat__close")) {
      previous.replaceWith(replacement);
    } else if (copyBlock) {
      header.insertBefore(replacement, copyBlock);
    } else {
      header.insertBefore(replacement, header.firstChild);
    }
  }

  function renderHome() {
    content.innerHTML = `
      <div class="monello-chat__compact-home">
        <p class="monello-chat__compact-welcome">
          🤍 Wie können wir Dich in dieser schweren Zeit unterstützen?
        </p>

        <button
          type="button"
          class="monello-chat__quick-start"
        >
          <span class="monello-chat__quick-start-icon" aria-hidden="true">✦</span>
          <span class="monello-chat__quick-start-copy">
            <span class="monello-chat__quick-start-title">Soforthilfe</span>
            <span class="monello-chat__quick-start-subtitle">Bestellung, Rückgabe &amp; wichtige Themen</span>
          </span>
          <span class="monello-chat__quick-start-arrow" aria-hidden="true">›</span>
        </button>

        <div class="monello-chat__bottom-area">
        <form class="monello-chat__start-form">
          <div class="monello-chat__composer-row">
          <button
            type="button"
            class="monello-chat__attach"
            aria-label="Bilder hochladen und einer Bestellung zuordnen"
          >
            📎
          </button>
          <input
            class="monello-chat__file-input"
            type="file"
            accept="image/jpeg,image/png,image/webp"
            multiple
            hidden
          >
          <textarea
            class="monello-chat__start-input"
            rows="2"
            maxlength="500"
            placeholder="Wie können wir Dir helfen?"
            aria-label="Deine Nachricht"
            required
          ></textarea>
          <button
            type="submit"
            class="monello-chat__send"
            aria-label="Nachricht senden"
          >
            ➤
          </button>
          </div>
          ${privacyNoticeHtml(true)}
        </form>
        </div>
      </div>
    `;

    content.querySelector(
      ".monello-chat__quick-start"
    ).addEventListener("click", renderQuickHelp);

    attachAutoGrow(
      content.querySelector(".monello-chat__start-input"),
      "home"
    );

    setupAttachmentUpload(renderHome);
    setupPrivacyControls();

    connectStartCards(renderHome);
  }

  function attachAutoGrow(textarea, mode = "conversation") {
    if (!textarea) return;

    function resizeTextarea() {
      const availableHeight = mode === "home"
        ? Math.max(110, Math.min(230, content.clientHeight - 145))
        : 150;

      textarea.style.height = "auto";
      const nextHeight = Math.min(
        textarea.scrollHeight,
        availableHeight
      );
      textarea.style.height = `${Math.max(48, nextHeight)}px`;
      textarea.style.overflowY =
        textarea.scrollHeight > availableHeight ? "auto" : "hidden";
    }

    textarea.addEventListener("input", resizeTextarea);
    resizeTextarea();
  }

  function renderQuickHelp() {
    content.innerHTML = `
      <div class="monello-chat__quick-page">
        <button
          type="button"
          class="monello-chat__back--compact"
        >
          ← Zurück
        </button>

        <h3 class="monello-chat__quick-heading">
          Wobei dürfen wir Dir helfen?
        </h3>

        <p class="monello-chat__quick-section-title">
          Bestellung &amp; Service
        </p>
        <div class="monello-chat__quick-grid">
          <button class="monello-chat__quick-card" type="button"
            data-chat-message="Wann kommt meine Bestellung?">
            <span class="monello-chat__quick-icon">📦</span>
            <span>Bestellstatus</span>
          </button>
          <button class="monello-chat__quick-card" type="button"
            data-chat-message="Wie kann ich eine Urne zurücksenden?">
            <span class="monello-chat__quick-icon">↩️</span>
            <span>Rücksendung</span>
          </button>
          <button class="monello-chat__quick-card monello-chat__complaint-button" type="button">
            <span class="monello-chat__quick-icon">📷</span>
            <span>Reklamation</span>
          </button>
          <button class="monello-chat__quick-card monello-chat__callback-button" type="button">
            <span class="monello-chat__quick-icon">☎️</span>
            <span>Rückrufwunsch</span>
          </button>
          <button class="monello-chat__quick-card monello-chat__upload-button"
            type="button">
            <span class="monello-chat__quick-icon">🖼️</span>
            <span>Bilder hochladen</span>
          </button>
        </div>

        <p class="monello-chat__quick-section-title">
          Hilfe &amp; Orientierung
        </p>
        <div class="monello-chat__quick-grid">
          <a class="monello-chat__quick-card"
            href="https://monello-tierurnen.de/pages/was-tun-wenn-tier-stirbt">
            <span class="monello-chat__quick-icon">🤍</span>
            <span>Hilfe im Trauerfall</span>
          </a>
          <button class="monello-chat__quick-card monello-chat__finder-button"
            type="button">
            <span class="monello-chat__quick-icon">📍</span>
            <span>Bestattung finden</span>
          </button>
          <a class="monello-chat__quick-card"
            href="https://monello-tierurnen.de/pages/erinnerungslichter">
            <span class="monello-chat__quick-icon">🕯️</span>
            <span>Erinnerungslichter</span>
          </a>
        </div>
      </div>
    `;

    content.querySelector(
      ".monello-chat__back--compact"
    ).addEventListener("click", renderHome);

    content.querySelector(
      ".monello-chat__finder-button"
    ).addEventListener("click", renderFinderHelp);

    content.querySelector(
      ".monello-chat__upload-button"
    ).addEventListener("click", () => {
      showConversation(renderQuickHelp);
      showAttachmentAssignmentForm();
    });

    content.querySelector(
      ".monello-chat__callback-button"
    ).addEventListener("click", () => {
      showConversation(renderQuickHelp);
      showCallbackRequestForm();
    });

    content.querySelector(
      ".monello-chat__complaint-button"
    ).addEventListener("click", () => {
      showConversation(renderQuickHelp);
      showComplaintRequestForm();
    });

    connectStartCards(renderQuickHelp);
  }

  /* MONELLO_ORDER_STATUS_RENDER_V1 */
  function renderOrderStatusPage(backTarget = renderQuickHelp) {
    content.innerHTML = `
      <div class="monello-chat__order-status-page">
        <div class="monello-chat__order-status-toolbar">
          <button
            type="button"
            class="monello-chat__order-status-back"
          >
            ← Zurück
          </button>
          <span class="monello-chat__order-status-title">
            Bestellstatus
          </span>
          <a
            class="monello-chat__order-status-external"
            data-order-status-external
            href="https://monello-tierurnen.de/pages/bestellstatus"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Bestellstatus in neuem Fenster öffnen"
          >
            ↗
          </a>
        </div>
        <div class="monello-chat__order-status-frame-wrap">
          <iframe
            class="monello-chat__order-status-frame"
            src="/pages/bestellstatus?monello_chat_embed=bestellstatus"
            title="Bestellstatus prüfen"
            loading="eager"
          ></iframe>
        </div>
      </div>
    `;

    content.querySelector(
      ".monello-chat__order-status-back"
    ).addEventListener("click", () => {
      backTarget();
    });
  }

  function renderFinderHelp() {
    content.innerHTML = `
      <div class="monello-chat__quick-page">
        <button
          type="button"
          class="monello-chat__back--compact"
        >
          ← Zur Soforthilfe
        </button>
        <h3 class="monello-chat__quick-heading">
          Krematorium oder Bestattung finden
        </h3>
        <p class="monello-chat__finder-info">
          Hier findest Du passende Anlaufstellen für Tiere sowie Angebote
          rund um Friedwald, See- und weitere Bestattungsformen.
        </p>
        <div class="monello-chat__finder-links">
          <a class="monello-chat__finder-link"
            href="https://monello-tierurnen.de/pages/tierkrematorium-finden">
            Tierkrematorium finden
          </a>
          <a class="monello-chat__finder-link"
            href="https://monello-tierurnen.de/pages/bestatter-friedwald-seebestattungs-finder">
            Bestatter, Friedwald &amp; Seebestattung
          </a>
        </div>
      </div>
    `;

    content.querySelector(
      ".monello-chat__back--compact"
    ).addEventListener("click", renderQuickHelp);
  }

  function showConversation(backTarget = renderHome) {
    content.innerHTML = `
      <div class="monello-chat__conversation">
        <button
          type="button"
          class="monello-chat__back"
          aria-label="Zurück zur Themenauswahl"
        >
          ← Zurück
        </button>
        <button
          type="button"
          class="monello-chat__new-chat"
          style="align-self:flex-start;padding:2px 0 6px;border:0;background:transparent;color:#8f624f;cursor:pointer;font:inherit;font-size:11px;font-weight:700"
        >
          ↻ Neue Unterhaltung
        </button>

        <div
          class="monello-chat__messages"
          aria-live="polite"
        ></div>

        <div
          class="monello-chat__typing"
          hidden
        >
          Bella schreibt …
        </div>

        <form class="monello-chat__form">
          <label
            class="monello-chat__form-label"
            for="monello-chat-input"
          >
            Deine Nachricht
          </label>

<div class="monello-chat__form-row">

    <button
        type="button"
        class="monello-chat__attach"
        aria-label="Bild auswählen"
    >
        📎
    </button>

    <input
        id="monello-chat-file"
        type="file"
        accept="image/jpeg,image/png,image/webp"
        multiple
        hidden
    >

    <textarea
        id="monello-chat-input"
        class="monello-chat__input"
        rows="2"
        maxlength="500"
        placeholder="Schreibe deine Nachricht …"
        autocomplete="off"
        required
    ></textarea>

    <button
        type="submit"
        class="monello-chat__send"
        aria-label="Nachricht senden"
    >
        ➤
    </button>

</div>
          ${privacyNoticeHtml(true)}
        </form>
 
      </div>
    `;

    const backButton = content.querySelector(
      ".monello-chat__back"
    );

    const form = content.querySelector(
      ".monello-chat__form"
    );

    const input = content.querySelector(
      ".monello-chat__input"
    );

    attachAutoGrow(input);

    setupAttachmentUpload(backTarget);
    setupPrivacyControls();

    backButton.addEventListener("click", () => {

  backTarget();

});

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      const message = input.value.trim();

      if (!message) return;

      input.value = "";
      input.dispatchEvent(new Event("input"));

      await sendMessage(message, true);
    });
  }

  function privacyNoticeHtml(withDelete = false) {
    return `
      <p class="monello-chat__privacy-note" style="margin:8px 4px 0;font-size:10px;line-height:1.35;color:#76665f;text-align:center">
        Deine Angaben werden nur zur Bearbeitung Deiner Anfrage verarbeitet.
        <a data-privacy-link href="https://monello-tierurnen.de/pages/datenschutz" target="_blank" rel="noopener noreferrer" style="color:#8f624f;text-decoration:underline">Datenschutzhinweise</a>
        ${withDelete ? ` · <button type="button" data-delete-chat style="border:0;background:none;padding:0;color:#8f624f;text-decoration:underline;font:inherit;cursor:pointer">Chatdaten löschen</button>` : ""}
      </p>
    `;
  }

  function setupPrivacyControls() {
    content.querySelectorAll("[data-privacy-link]").forEach((link) => {
      link.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    });

    const deleteButton = content.querySelector("[data-delete-chat]");
    if (!deleteButton) return;
    deleteButton.addEventListener("click", async () => {
      if (!window.confirm("Möchtest Du diesen Chat und die dazu hochgeladenen Dateien wirklich löschen?")) return;
      deleteButton.disabled = true;
      try {
        const response = await fetch(deleteChatUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        localStorage.removeItem("monello_chat_session_id");
        sessionStorage.removeItem("monello_chat_session_id");
        sessionStorage.removeItem(trackingStorageKey);
        sessionStorage.removeItem(windowOpenStorageKey);
        window.location.reload();
      } catch (error) {
        deleteButton.disabled = false;
        window.alert("Die Chatdaten konnten gerade nicht gelöscht werden. Bitte versuche es erneut oder schreibe an info@monello-tierurnen.de.");
      }
    });
  }

  function setupAttachmentUpload(backTarget = renderHome) {
    const attachButton = content.querySelector(".monello-chat__attach");
    if (!attachButton) return;

    attachButton.addEventListener("click", () => {
      if (!content.querySelector(".monello-chat__messages")) {
        showConversation(backTarget);
      }

      showAttachmentAssignmentForm();
    });
  }

  function showAttachmentAssignmentForm() {
    const messages = content.querySelector(".monello-chat__messages");
    if (!messages) return;

    messages.querySelector(".monello-chat__assignment-form")?.remove();

    const panel = document.createElement("form");
    panel.className = "monello-chat__assignment-form";
    panel.style.cssText =
      "padding:14px;border:1px solid #eadbd3;border-radius:16px;background:#fff;display:grid;gap:9px;box-shadow:0 9px 22px rgba(80,55,45,.08)";
    panel.innerHTML = `
      <strong>Bilder sicher zuordnen</strong>
      <label style="display:grid;gap:5px;font-size:12px;font-weight:700;color:#4a3b35">
        Bilder auswählen
        <input name="upload_files" type="file" accept="image/jpeg,image/png,image/webp" multiple required style="width:100%;padding:9px;border:1px solid #dccbc2;border-radius:10px;background:#fff">
      </label>
      <select name="purpose" required style="padding:10px;border:1px solid #dccbc2;border-radius:10px;background:#fff">
        <option value="">Verwendungszweck wählen</option>
        <option value="portrait">Portraitvorlage</option>
        <option value="personalization">Personalisierung / Gravur</option>
        <option value="complaint">Reklamation</option>
        <option value="other">Sonstige Bestellunterlagen</option>
      </select>
      <input name="order_number" placeholder="Bestellnummer, z. B. #2026" style="padding:10px;border:1px solid #dccbc2;border-radius:10px">
      <input name="customer_name" placeholder="Vollständiger Name" style="padding:10px;border:1px solid #dccbc2;border-radius:10px">
      <input name="customer_email" type="email" placeholder="E-Mail-Adresse der Bestellung" required style="padding:10px;border:1px solid #dccbc2;border-radius:10px">
      <textarea name="description" rows="2" placeholder="Kurzer Hinweis zu den Bildern" style="padding:10px;border:1px solid #dccbc2;border-radius:10px;resize:vertical"></textarea>
      <small>Zur sicheren Zuordnung bitte Bestellnummer und E-Mail-Adresse angeben. Alternativ sind vollständiger Name und E-Mail-Adresse möglich.</small>
      <small>Bitte keine Zahlungsdaten, Passwörter oder nicht benötigte persönliche Inhalte hochladen.</small>
      <label style="display:flex;gap:8px;align-items:flex-start;font-size:11px;line-height:1.4;color:#65564f">
        <input type="checkbox" required style="margin-top:2px">
        <span>Ich habe die <a href="${privacyUrl}" target="_blank" rel="noopener noreferrer" style="color:#8f624f">Datenschutzhinweise</a> gelesen.</span>
      </label>
      <div style="display:flex;gap:8px">
        <button type="submit" style="flex:1;padding:11px;border:0;border-radius:11px;background:linear-gradient(135deg,#b98b73,#8f624f);color:#fff;font-weight:700">Sicher zuordnen</button>
        <button type="button" data-cancel style="padding:11px;border:1px solid #dccbc2;border-radius:11px;background:#fff;color:#4a3b35">Abbrechen</button>
      </div>
    `;

    messages.appendChild(panel);
    messages.scrollTop = messages.scrollHeight;

    panel.querySelector("[data-cancel]").addEventListener("click", () => {
      panel.remove();
    });

    panel.addEventListener("submit", async (event) => {
      event.preventDefault();
      const submit = panel.querySelector("button[type='submit']");
      submit.disabled = true;
      submit.textContent = "Wird sicher gespeichert …";

      const values = new FormData(panel);
      const uploadInput = panel.querySelector("[name='upload_files']");
      const selectedFiles = Array.from(uploadInput.files || []);
      const allowedTypes = ["image/jpeg", "image/png", "image/webp"];

      if (!selectedFiles.length) {
        submit.disabled = false;
        submit.textContent = "Sicher zuordnen";
        alert("Bitte wähle mindestens ein Bild aus.");
        return;
      }
      if (selectedFiles.length > 10) {
        submit.disabled = false;
        submit.textContent = "Sicher zuordnen";
        alert("Bitte wähle höchstens 10 Bilder aus.");
        return;
      }
      if (selectedFiles.some((file) => !allowedTypes.includes(file.type))) {
        submit.disabled = false;
        submit.textContent = "Sicher zuordnen";
        alert("Erlaubt sind JPG-, PNG- und WEBP-Bilder.");
        return;
      }
      if (selectedFiles.some((file) => file.size > 8 * 1024 * 1024)) {
        submit.disabled = false;
        submit.textContent = "Sicher zuordnen";
        alert("Ein Bild darf höchstens 8 MB groß sein.");
        return;
      }

      const formData = new FormData();
      formData.append("session_id", sessionId);
      for (const field of [
        "purpose",
        "order_number",
        "customer_name",
        "customer_email",
        "description",
      ]) {
        formData.append(field, values.get(field) || "");
      }
      selectedFiles.forEach((file) => formData.append("files", file));

      try {
        const response = await fetch(
          "https://monello-ai-production.up.railway.app/chat/attachments",
          { method: "POST", body: formData }
        );
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.detail || `HTTP ${response.status}`);
        }
        panel.remove();
        addMessage(messages, data.answer, "assistant");
      } catch (error) {
        console.error("Monello-Bilderupload:", error);
        submit.disabled = false;
        submit.textContent = "Erneut versuchen";
        addMessage(
          messages,
          `Die Bilder konnten noch nicht zugeordnet werden: ${error.message}`,
          "assistant"
        );
      } finally {
        uploadInput.value = "";
      }
    });
  }

  function showComplaintRequestForm() {
    const messages = content.querySelector(".monello-chat__messages");
    if (!messages) return;

    messages.querySelector(".monello-chat__assignment-form")?.remove();
    messages.querySelector(".monello-chat__callback-form")?.remove();
    messages.querySelector(".monello-chat__complaint-form")?.remove();

    const panel = document.createElement("form");
    panel.className = "monello-chat__complaint-form";
    panel.style.cssText =
      "padding:14px;border:1px solid #eadbd3;border-radius:16px;background:#fff;display:grid;gap:9px;box-shadow:0 9px 22px rgba(80,55,45,.08)";
    panel.innerHTML = `
      <strong>Reklamation einreichen</strong>
      <p style="margin:0;font-size:12px;line-height:1.45;color:#6b5a53">Bitte beschreibe den Defekt und lade gut erkennbare Fotos hoch. Unsere Reklamationsabteilung prüft anschließend alles und meldet sich schnellstmöglich bei Dir.</p>
      <input name="order_number" autocomplete="off" placeholder="Bestellnummer, z. B. #2026" required style="padding:10px;border:1px solid #dccbc2;border-radius:10px">
      <input name="customer_name" autocomplete="name" placeholder="Vollständiger Name" required style="padding:10px;border:1px solid #dccbc2;border-radius:10px">
      <input name="customer_email" type="email" autocomplete="email" placeholder="E-Mail-Adresse der Bestellung" required style="padding:10px;border:1px solid #dccbc2;border-radius:10px">
      <textarea name="description" rows="4" placeholder="Was ist beschädigt oder fehlerhaft angekommen?" minlength="5" required style="padding:10px;border:1px solid #dccbc2;border-radius:10px;resize:vertical"></textarea>
      <label style="display:grid;gap:5px;font-size:12px;font-weight:700;color:#4a3b35">
        Fotos des Defekts (1 bis 5)
        <input name="complaint_files" type="file" accept="image/jpeg,image/png,image/webp" multiple required style="width:100%;padding:9px;border:1px solid #dccbc2;border-radius:10px;background:#fff">
      </label>
      <small>Erlaubt sind JPG, PNG und WEBP mit höchstens 8 MB je Foto.</small>
      <small>Bitte keine Zahlungsdaten, Passwörter oder nicht benötigte persönliche Inhalte hochladen.</small>
      <label style="display:flex;gap:8px;align-items:flex-start;font-size:11px;line-height:1.4;color:#65564f">
        <input type="checkbox" required style="margin-top:2px">
        <span>Ich habe die <a href="${privacyUrl}" target="_blank" rel="noopener noreferrer" style="color:#8f624f">Datenschutzhinweise</a> gelesen.</span>
      </label>
      <div style="display:flex;gap:8px">
        <button type="submit" style="flex:1;padding:11px;border:0;border-radius:11px;background:linear-gradient(135deg,#b98b73,#8f624f);color:#fff;font-weight:700">Reklamation übermitteln</button>
        <button type="button" data-cancel style="padding:11px;border:1px solid #dccbc2;border-radius:11px;background:#fff;color:#4a3b35">Abbrechen</button>
      </div>
    `;

    messages.appendChild(panel);
    messages.scrollTop = messages.scrollHeight;
    panel.querySelector("[data-cancel]").addEventListener("click", () => panel.remove());

    panel.addEventListener("submit", async (event) => {
      event.preventDefault();
      const submit = panel.querySelector("button[type='submit']");
      const uploadInput = panel.querySelector("[name='complaint_files']");
      const selectedFiles = Array.from(uploadInput.files || []);
      const allowedTypes = ["image/jpeg", "image/png", "image/webp"];

      if (!selectedFiles.length || selectedFiles.length > 5) {
        alert("Bitte wähle zwischen 1 und 5 Fotos aus.");
        return;
      }
      if (selectedFiles.some((file) => !allowedTypes.includes(file.type))) {
        alert("Erlaubt sind JPG-, PNG- und WEBP-Bilder.");
        return;
      }
      if (selectedFiles.some((file) => file.size > 8 * 1024 * 1024)) {
        alert("Ein Foto darf höchstens 8 MB groß sein.");
        return;
      }

      submit.disabled = true;
      submit.textContent = "Wird sicher übermittelt …";
      const values = new FormData(panel);
      const formData = new FormData();
      formData.append("session_id", sessionId);
      for (const field of ["order_number", "customer_name", "customer_email", "description"]) {
        formData.append(field, values.get(field) || "");
      }
      selectedFiles.forEach((file) => formData.append("files", file));

      try {
        const response = await fetch(
          "https://monello-ai-production.up.railway.app/chat/complaint",
          { method: "POST", body: formData }
        );
        const data = await response.json();
        if (!response.ok) throw new Error(data.detail || `HTTP ${response.status}`);
        panel.remove();
        addMessage(messages, "Reklamation mit Fotos übermittelt", "user");
        addMessage(messages, data.answer, "assistant");
      } catch (error) {
        console.error("Monello-Reklamation:", error);
        submit.disabled = false;
        submit.textContent = "Erneut versuchen";
        addMessage(messages, `Die Reklamation konnte noch nicht übermittelt werden: ${error.message}`, "assistant");
      }
    });
  }

  function showCallbackRequestForm() {
    const messages = content.querySelector(".monello-chat__messages");
    if (!messages) return;

    messages.querySelector(".monello-chat__callback-form")?.remove();

    const panel = document.createElement("form");
    panel.className = "monello-chat__callback-form";
    panel.style.cssText =
      "padding:14px;border:1px solid #eadbd3;border-radius:16px;background:#fff;display:grid;gap:9px;box-shadow:0 9px 22px rgba(80,55,45,.08)";
    panel.innerHTML = `
      <strong>Rückrufwunsch</strong>
      <p style="margin:0;font-size:12px;line-height:1.45;color:#6b5a53">Bitte fülle die Angaben aus. Wir speichern Deinen Rückrufwunsch anschließend direkt für unser Team.</p>
      <input name="customer_name" autocomplete="name" placeholder="Vollständiger Name" required style="padding:10px;border:1px solid #dccbc2;border-radius:10px">
      <input name="phone" type="tel" autocomplete="tel" placeholder="Telefonnummer" required style="padding:10px;border:1px solid #dccbc2;border-radius:10px">
      <input name="preferred_time" placeholder="Gut erreichbar, z. B. werktags 14–17 Uhr" required style="padding:10px;border:1px solid #dccbc2;border-radius:10px">
      <textarea name="reason" rows="3" placeholder="Worum geht es?" required style="padding:10px;border:1px solid #dccbc2;border-radius:10px;resize:vertical"></textarea>
      <label style="display:flex;gap:8px;align-items:flex-start;font-size:11px;line-height:1.4;color:#65564f">
        <input type="checkbox" required style="margin-top:2px">
        <span>Ich habe die <a href="${privacyUrl}" target="_blank" rel="noopener noreferrer" style="color:#8f624f">Datenschutzhinweise</a> gelesen.</span>
      </label>
      <div style="display:flex;gap:8px">
        <button type="submit" style="flex:1;padding:11px;border:0;border-radius:11px;background:linear-gradient(135deg,#b98b73,#8f624f);color:#fff;font-weight:700">Rückruf anfordern</button>
        <button type="button" data-cancel style="padding:11px;border:1px solid #dccbc2;border-radius:11px;background:#fff;color:#4a3b35">Abbrechen</button>
      </div>
    `;

    messages.appendChild(panel);
    messages.scrollTop = messages.scrollHeight;
    panel.querySelector("[data-cancel]").addEventListener("click", () => panel.remove());

    panel.addEventListener("submit", async (event) => {
      event.preventDefault();
      const submit = panel.querySelector("button[type='submit']");
      const values = new FormData(panel);
      submit.disabled = true;
      submit.textContent = "Wird gespeichert …";

      try {
        const response = await fetch(
          "https://monello-ai-production.up.railway.app/chat/callback",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              session_id: sessionId,
              name: values.get("customer_name") || "",
              phone: values.get("phone") || "",
              preferred_time: values.get("preferred_time") || "",
              reason: values.get("reason") || "",
              page_url: window.location.href,
              page_title: document.title,
            }),
          }
        );
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.detail || `HTTP ${response.status}`);
        }
        panel.remove();
        addMessage(messages, "Rückrufwunsch übermittelt", "user");
        addMessage(messages, data.answer, "assistant");
      } catch (error) {
        console.error("Monello-Rückrufwunsch:", error);
        submit.disabled = false;
        submit.textContent = "Erneut versuchen";
        addMessage(
          messages,
          `Der Rückrufwunsch konnte noch nicht gespeichert werden: ${error.message}`,
          "assistant"
        );
      }
    });
  }

function connectStartCards(backTarget = renderHome) {
  const cards = content.querySelectorAll(
    "[data-chat-message]"
  );

  const startForm = content.querySelector(
    ".monello-chat__start-form"
  );

  const startInput = content.querySelector(
    ".monello-chat__start-input"
  );

  cards.forEach((card) => {
    card.addEventListener("click", async () => {
      const message = card.dataset.chatMessage;

      if (!message) return;

      showConversation(backTarget);

      await sendMessage(
        message,
        false
      );
    });
  });

  if (startForm && startInput) {
    startForm.addEventListener(
      "submit",
      async (event) => {
        event.preventDefault();

        const message = startInput.value.trim();

        if (!message) return;

        showConversation(backTarget);

        await sendMessage(
          message,
          true
        );
      }
    );
  }
}

async function sendMessage(
  message,
  showUserMessage
) {
  const messages = content.querySelector(
    ".monello-chat__messages"
  );

  const typing = content.querySelector(
    ".monello-chat__typing"
  );

  const input = content.querySelector(
    ".monello-chat__input"
  );

  if (!messages) return;

  if (showUserMessage) {
    addMessage(
      messages,
      message,
      "user"
    );
  }

  if (typing) {
    typing.hidden = false;
  }

  if (input) {
    input.disabled = true;
  }

  messageRequestInFlight = true;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message: message,
        session_id: sessionId,
        page_url: window.location.href,
        page_title: String(
          document.querySelector("main h1")?.innerText || document.title
        ).replace(/\s+/g, " ").trim(),
        page_context: collectProductPageContext(),
      }),
    });

    if (!response.ok) {
      throw new Error(
        `HTTP-Fehler ${response.status}`
      );
    }

    const data = await response.json();

    lastMessageId = Math.max(
      lastMessageId,
      Number(data.last_id || 0)
    );

    const answer = data.answer || data.message || "";
    if (answer) {
      addMessage(
        messages,
        answer,
        "assistant"
      );
    }
    startLivePolling();
  } catch (error) {
    console.error(
      "Monello-Chatfehler:",
      error
    );

    addMessage(
      messages,
      "Entschuldige, die Verbindung zu unserem Erinnerungsberater ist gerade nicht möglich. Bitte versuche es in einem Moment erneut.",
      "assistant"
    );
  } finally {
    messageRequestInFlight = false;

    if (typing) {
      typing.hidden = true;
    }

    if (input) {
      input.disabled = false;
      input.focus();
    }
  }
}

  function escapeHtml(value) {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function renderMarkdown(text) {
    let html = escapeHtml(text);

    // Geschützte Digitalentwürfe nach erfolgreicher Bestellprüfung.
    html = html.replace(
      /!\[([^\]]*)\]\((https?:\/\/[^\s)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer" style="display:block">' +
      '<img src="$2" alt="$1" loading="lazy" ' +
      'style="display:block;width:100%;max-height:260px;object-fit:contain;' +
      'margin:8px 0;border-radius:12px;background:#fff" /></a>'
    );

    // Links: [Sendung verfolgen](https://...)
    html = html.replace(
      /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    // Fettschrift: **Text**
    html = html.replace(
      /\*\*(.+?)\*\*/g,
      "<strong>$1</strong>"
    );

    // Listen mit Bindestrich
    html = html.replace(
      /(^|\n)-\s+(.+?)(?=\n|$)/g,
      '$1<span class="monello-chat__list-item">• $2</span>'
    );

    // Zeilenumbrüche
    html = html.replace(/\n/g, "<br>");

    return html;
  }

  function addHumanHandoffButton(messages) {
  const existingButton = messages.querySelector(
    ".monello-chat__handoff-button"
  );

  if (existingButton) return;

  const button = document.createElement("button");

  button.type = "button";
  button.className = "monello-chat__handoff-button";
  button.textContent =
    "👤 Persönliche Beratungsanfrage senden";

  button.addEventListener("click", () => {
    addMessage(
      messages,
      "Ich möchte eine persönliche Beratungsanfrage senden.",
      "user"
    );

    addMessage(
      messages,
      "Sehr gerne. Wie ist Dein vollständiger Name?",
      "assistant"
    );

    button.remove();
  });

  messages.appendChild(button);

  messages.scrollTop =
    messages.scrollHeight;
}

  function addMessage(
    messages,
    text,
    sender
  ) {
    const messageElement =
      document.createElement("div");

    messageElement.className =
      `monello-chat__message monello-chat__message--${sender}`;

    const bubble =
      document.createElement("div");

    bubble.className =
      "monello-chat__message-bubble";

    bubble.innerHTML = renderMarkdown(text);

    if (sender === "assistant") {
      const icon =
        document.createElement("span");

      icon.className =
        "monello-chat__message-icon";

      icon.textContent = "🤍";

      messageElement.appendChild(icon);
    }

    messageElement.appendChild(bubble);
    messages.appendChild(messageElement);


    messages.scrollTop =
      messages.scrollHeight;
  }
});